export const UPDATE_PROFILE_NAME = 'updateProfile';
export const UPDATE_PROFILE_PREFIX = `@@${UPDATE_PROFILE_NAME}`;



// WEBPACK FOOTER //
// ./src/js/user-profile/redux/state.js